const MEASUREMENT_ID = import.meta.env.VITE_GA4_MEASUREMENT_ID;

// GA4 truncates event parameter values past 100 characters, so callers cut
// their own values rather than letting Google decide where the cut lands.
export const PARAM_VALUE_MAX_LENGTH = 100;

if (MEASUREMENT_ID) {
  window.dataLayer = window.dataLayer || [];
  // Google's published shim. It has to forward `arguments` untouched: the
  // gtag library drains the queue and reads each entry positionally.
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${MEASUREMENT_ID}`;
  document.head.appendChild(script);

  window.gtag("js", new Date());
  window.gtag("config", MEASUREMENT_ID, {
    // AnalyticsProvider sends a page_view per route change. The load-time one
    // would count only the first screen of the session.
    send_page_view: false,
    // Setting debug_mode to false does not disable it, so the key is left out
    // entirely outside development.
    ...(import.meta.env.DEV && { debug_mode: true }),
  });
}

export function isAnalyticsEnabled() {
  return Boolean(MEASUREMENT_ID);
}

export function trackEvent(name, params = {}) {
  if (!MEASUREMENT_ID) return;
  window.gtag("event", name, params);
}

// gtag stamps these onto every subsequent event, so page_view, button_click
// and select_content all report the same screen without each call repeating it.
export function setPageContext(params) {
  if (!MEASUREMENT_ID) return;
  window.gtag("set", params);
}

export function trackPageView(params = {}) {
  trackEvent("page_view", params);
}
